import React from "react";

import styled from "styled-components";

import { colors } from "shared/config/constants";


const Notice = styled.div`
  background: #fff;
  border: 1px solid ${colors.neutral[400]};
  border-radius: 8px;
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Text = styled.p`
  font-size: 12.5px;
  font-weight: 300;
  line-height: 1.6;
  color: ${colors.primary[400]};
  margin: 0;
  max-width: 74ch;
`;

export const ApplicantProvidedNotice = () => (
  <Notice data-testid="applicant-provided-notice">
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke={colors.primary[400]}
      strokeWidth="1.8"
      strokeLinecap="round"
      style={{ flex: "0 0 auto" }}
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5" />
      <path d="M12 8h.01" />
    </svg>
    <Text>The information below was provided by the applicant.</Text>
  </Notice>
);
